export function protectedDocumentPath(path) {
  const pathname = String(path || '')

  return pathname === '/sign_in' ||
    pathname === '/password' ||
    pathname.startsWith('/password/') ||
    (pathname === '/portal' || pathname.startsWith('/portal/')) ||
    (pathname === '/admin' || pathname.startsWith('/admin/')) ||
    (pathname === '/partner' || pathname.startsWith('/partner/')) ||
    pathname.startsWith('/verify/') ||
    pathname.startsWith('/booking/confirmation/') ||
    pathname.startsWith('/program-guide/thank-you') ||
    pathname.startsWith('/program-guide/download/')
}

export function installPrivacyNavigationBoundary(router, browserWindow = window) {
  const initialDocumentIsProtected = protectedDocumentPath(browserWindow.location.pathname)

  return router.on('before', event => {
    const visit = event?.detail?.visit
    // A document boundary must not turn a mutation (notably DELETE sign-out) into a GET.
    if (!visit?.url || visit.method !== 'get') return

    const destination = new URL(visit.url, browserWindow.location.origin)
    if (protectedDocumentPath(destination.pathname) === initialDocumentIsProtected) return

    event.preventDefault()
    browserWindow.location.assign(destination.href)
  })
}
